import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { districtConfig } from '../config/districtConfig';

export default function DistrictManagement() {
  return <CRUDManager config={districtConfig} />;
}